<form [formGroup]="form" (submit)="onSubmit($event)">
  <input
    type="number"
    class="new-link"
    placeholder="(enter to save)"
    [formControl]="proAccountId"
    autofocus
  />
  <p class="text-danger" *ngIf="showFormInvalidMessage">
    Pro Account Id must be shorter then 10 digits and of type number
  </p>
</form>
